import React from 'react';
import style from '../../assets/common/CommonStyle.module.css';
import fieldStyle from '../CreateInvoice/CreateInvoicePopup/CreateInvoicePopup.module.css';
import CommonSvgSelector from '../../assets/common/SVG/CommonSvgSelector';
import addressStyle from '../Cart/Cart.module.css';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {CustomInput} from '../../Components/Input';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import GreenButton from '../../Components/Buttons/GreenButton';
import s from './PaperworkList.module.css';
import {
	useCashDepositMutation,
	useCashWithdrawalMutation,
} from '../../redux/DepotSlice/depotCashierApi';
import {useClickOutside} from '../../hooks/useClickOutside';
import {useTranslation} from 'react-i18next';
import {CashActionType} from '../../types/CashierSliceStateType';
import {toast} from 'react-toastify';
import {validationFilterForm} from '../../assets/utils/validation';

interface Props {
	close: () => void;
	popup: CashPopupType;
}

export type CashPopupType = {
	title: string;
	type: 'deposit' | 'withdrawal';
	shift_id: string;
};

const PaperWorkCashPopup: React.FC<Props> = ({close, popup}) => {
	const {t} = useTranslation();
	const outerContainerRef = useClickOutside<HTMLDivElement>(close);
	const [cashDeposit] = useCashDepositMutation();
	const [cashWithdrawal] = useCashWithdrawalMutation();

	const handleSubmit = async (values: CashActionType) => {
		try {
			const response =
				popup.type === 'deposit'
					? await cashDeposit(values).unwrap()
					: await cashWithdrawal(values).unwrap();
			toast.success(response?.message?.textmsg || t('Успішно'));
			close();
		} catch (error: any) {
			toast.error(error?.data?.message?.textmsg || t('Помилка'));
		}
	};
	const initialValues: CashActionType = {
		sum_cash: '',
		shift_id: popup.shift_id,
	};
	return (
		<div className={style.popupWrapper} ref={outerContainerRef}>
			<div className={`${style.popupContainer} ${fieldStyle.container}`}>
				<div className={fieldStyle.closeCross}>
					<span onClick={close} role="button" tabIndex={0}>
						<CommonSvgSelector id={'closeCross'} />
					</span>
				</div>
				<div className={fieldStyle.title}>
					<h4>{popup.title}</h4>
				</div>
				<Formik
					validationSchema={validationFilterForm}
					initialValues={initialValues}
					onSubmit={handleSubmit}
				>
					{({handleSubmit, resetForm}) => {
						return (
							<Form onSubmit={handleSubmit}>
                                <div className={addressStyle.inputName}>{t('сума')}</div>
                                <CustomInput name={'sum_cash'} placeholder={'100'} type="number" />
								<ErrorMessage
									name={'sum_cash'}
									className={s.error}
									component={'div'}
								/>
								<div className={s.buttons}>
									<LightGreenButton text={popup.title} type={'submit'} />
									<GreenButton
										text={t('Скинути')}
										type={'button'}
										onClick={() => resetForm()}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default PaperWorkCashPopup;
